import { useCallback, useEffect, useRef, useState } from "react";
import { MapViewRightAlleyState } from "./types";
export var useMapViewRightAlleyState = function (viewMode, searchMode, initialState) {
    if (initialState === void 0) { initialState = MapViewRightAlleyState.Placards; }
    var _a = useState(initialState), rightAlleyState = _a[0], setRightAlleyState = _a[1];
    var prevState = useRef();
    useEffect(function () {
        if (rightAlleyState !== MapViewRightAlleyState.None) {
            prevState.current = rightAlleyState;
        }
    }, [rightAlleyState]);
    useEffect(function () {
        setRightAlleyState(function (value) { return (value === MapViewRightAlleyState.None ? value : initialState); });
    }, [initialState, searchMode, viewMode]);
    var toggleRightAlley = useCallback(function () {
        if (rightAlleyState === MapViewRightAlleyState.None) {
            setRightAlleyState(prevState.current || MapViewRightAlleyState.Placards);
        }
        else {
            setRightAlleyState(MapViewRightAlleyState.None);
        }
    }, [rightAlleyState, setRightAlleyState]);
    var toggleLocationFilters = useCallback(function () {
        if (rightAlleyState === MapViewRightAlleyState.GeoFilters) {
            setRightAlleyState(MapViewRightAlleyState.Placards);
        }
        else {
            setRightAlleyState(MapViewRightAlleyState.GeoFilters);
        }
    }, [rightAlleyState, setRightAlleyState]);
    var toggleLayers = useCallback(function () {
        if (rightAlleyState === MapViewRightAlleyState.Layers) {
            setRightAlleyState(MapViewRightAlleyState.Placards);
        }
        else {
            setRightAlleyState(MapViewRightAlleyState.Layers);
        }
    }, [rightAlleyState, setRightAlleyState]);
    var togglePlacards = useCallback(function () {
        if (rightAlleyState !== MapViewRightAlleyState.None) {
            setRightAlleyState(MapViewRightAlleyState.Placards);
        }
    }, [setRightAlleyState, rightAlleyState]);
    return {
        rightAlleyState: rightAlleyState,
        setRightAlleyState: setRightAlleyState,
        toggleRightAlley: toggleRightAlley,
        toggleLocationFilters: toggleLocationFilters,
        toggleLayers: toggleLayers,
        togglePlacards: togglePlacards,
    };
};
//# sourceMappingURL=use-map-view-right-alley-state.js.map